import React from "react";
import { useState} from "react";

import {
	Stack,
	Box,
	Chip,
} from "@mui/material";
import LedgerSummary from "./LedgerSummary";

const currencyValue = [{ name: 'USD' }, { name: 'AUD' }, { name: 'CAD' }, { name: 'SGD' }, { name: 'AED' }, { name: 'TRY' }];

export default function InstaPay() {
	const [currency, setCurrency] = useState('USD');

	return (
		<>
			<Box
				sx={{
					background: "#FFFFFF",
					boxShadow: "0px 2px 8px rgba(3, 40, 120, 0.18)",
					borderRadius: "0px 18px 18px 18px",
					p: 5,
				}}
			>
				<Stack spacing={2} direction="row">
					{currencyValue.map((row, index) => (
						<Chip
							key={index}
							label={row.name}
							variant={currency === row.name ? '' : 'outlined'}
							color={currency === row.name ? 'primary' : 'default'}
							onClick={() => {
								setCurrency(row.name)
							}}
						/>
					))}

				</Stack>
			</Box>

			<br></br>
			<LedgerSummary currency={currency}/>
		</>
	);
}